module.exports = {"620921100":"中东镇","620921101":"鼎新镇","620921102":"金塔镇","620921103":"东坝镇","620921105":"航天镇","620921203":"大庄子乡","620921204":"古城乡","620921205":"西坝乡","620921209":"羊井子湾乡","620921400":"甘肃亚盛农工商集团有限责任公司","620921401":"工业园区管委会","620921402":"农林场站"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620921.json
// module id = 2720
// module chunks = 0